import { useQuery } from "@tanstack/react-query";
import { procurementPipelineApi } from "../api/procurementPipeline";

interface StatisticItem {
    status: string;
    status_display_text: string;
    count: number;
    percentage: number;
}

export const useFetchMaterialStatistics = ({ quickFilters }: { quickFilters: any }) => {
    const { data, isFetching, isPending, isError, refetch } = useQuery({
        // queryKey: ["material-request-statistics", quickFilters.workstream, quickFilters.site, quickFilters.programme, quickFilters.region],
        // queryFn: () => {
        //     return procurementPipelineApi.fetchMaterialStatistics({
        //         workstream_id: quickFilters.workstream || null,
        //         site_id: quickFilters.site || null,
        //         programme_id: quickFilters.programme || null,
        //         region_id: quickFilters.region || null,
        //     });
        // }
        queryKey: ["material-request-statistics"],
        queryFn: () => {
            return procurementPipelineApi.fetchMaterialStatistics();
        }

    });

    return {
        statistics: (data?.data || []) as StatisticItem[],
        isPending,
        isFetching,
        isError,
        refetch
    };
};

export const useFetchResourceStatistics = ({ quickFilters }: { quickFilters: any }) => {
    const { data, isFetching, isPending, isError, refetch } = useQuery({
        // queryKey: ["resource-request-statistics", quickFilters.workstream, quickFilters.site, quickFilters.programme, quickFilters.region],
        // queryFn: () => {
        //     return procurementPipelineApi.fetchResourceStatistics({
        //         workstream_id: quickFilters.workstream || null,
        //         site_id: quickFilters.site || null,
        //         programme_id: quickFilters.programme || null,
        //         region_id: quickFilters.region || null,
        //     });
        // }
        queryKey: ["resource-request-statistics"],
        queryFn: () => {
            return procurementPipelineApi.fetchResourceStatistics();
        },
    });

    return {
        statistics: (data?.data || []) as StatisticItem[],
        isPending,
        isFetching,
        isError,
        refetch
    };
};

